"use client";

import { useEffect } from "react";
import { initFirebaseRemoteConfig } from "@features/firebase";

export function FirebaseInitializer() {
  useEffect(() => {
    const initialize = async () => {
      await initFirebaseRemoteConfig();
    };
    initialize();
  }, []);

  return null;
}
